<template>
	<AssessmentCharacteristics class="great-leader-characteristics"
		:is-skeleton="isSkeleton"
		:high-type="highType"
		:characteristics="characteristics"
	>
		<template #icon>
			<FontAwesomeIcon
				:icon="[ `far`, `person-circle-check` ]"
			/>
		</template>
		<template #heading>{{ $t( "common.GreatLeaderCharacteristics__heading" ) }}</template>
	</AssessmentCharacteristics>
</template>

<script>
import CommonCharacteristics from "./CommonCharacteristicsProps";
import AssessmentCharacteristics from "./AssessmentCharacteristics";
export default {
	name: "GreatLeaderCharacteristics",
	mixins: [ CommonCharacteristics, ],
	components: {
		AssessmentCharacteristics,
	},
	computed: {
		characteristics() {
			return this.assessment?.teamingContent?.leader?.makesGreatLeader || "";
		},
	},
};
</script>

<style lang="scss" scoped></style>
